import React from "react";
import { purchaseTicketsSectionElementId } from "../RaffleByCampus";

function calculateTimeLeft(date) {
  const difference = +new Date(date) - +new Date();
  let timeLeft = {};
  if (difference > 0) {
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / 1000 / 60) % 60);
    const seconds = Math.floor((difference / 1000) % 60);
    timeLeft = {
      days: days || null,
      hours: days || hours ? hours : null,
      minutes: days || hours || minutes ? minutes : null,
      seconds: days || hours || minutes || seconds ? seconds : null,
    };
  }

  return timeLeft;
}

export default class ReactCountdownTimer extends React.PureComponent {
  state = { timeLeft: null };

  componentDidMount() {
    let endDate = new Date(this.props.endDate);
    const localOffsetDifference = 240 - new Date().getTimezoneOffset(); //get difference from EDT offset (raffe dates are in EDT)
    //(we're using 240 for EDT (60 x 4), as it's always in EDT vs EST (300) as it ends in July)
    if (localOffsetDifference) {
      endDate.setMinutes(endDate.getMinutes() + localOffsetDifference);
    }

    const initialTimeLeft = calculateTimeLeft(endDate);
    if (initialTimeLeft.days >= 7) {
      return;
    }

    this.timer = setInterval(() => {
      this.setState({ timeLeft: calculateTimeLeft(endDate) });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { timeLeft } = this.state;

    if (!timeLeft) {
      return "";
    }

    const timerComponents = Object.keys(timeLeft)
      .map((interval) => {
        if (timeLeft[interval] == null) {
          return null;
        }

        return (
          <p className="text-center fw-700" key={interval}>
            {timeLeft[interval]}
            <span className="text-center fw-700 block">{interval}</span>
          </p>
        );
      })
      .filter((tc) => tc);

    return (
      <div className="countdown-timer">
        <p className="uppercase-text fw-700 mr-32">Grand Draw closing in</p>
        <div className="flex flex-justify-center" style={{ gap: 32 }}>
          {timerComponents}
        </div>
        {this.props.sellerId && (
          <a
            href={`#${purchaseTicketsSectionElementId}`}
            className="buy-now-link"
          >
            Buy Now
          </a>
        )}
      </div>
    );
  }
}
